import { ReactNode, useEffect, useState } from 'react'

import { DefaultEventsMap } from '@socket.io/component-emitter'
import { Socket } from 'socket.io-client'

import { WebSocketContext } from '~/shared/components/WebSocketProvider/context.ts'
import { connect } from '~/shared/services/websocket.client.ts'
import { UserInfo } from '~/shared/types/user.ts'
import { isOnPrem } from '~/shared/utils/environment.ts'

export const WebSocketProvider = ({
  children,
  user,
}: {
  children: ReactNode,
  user?: UserInfo,
}) => {
  const {
    userId,
    sessionId,
    username,
  } = user || {}

  const [socket, setSocket] =
    useState<Socket<DefaultEventsMap, DefaultEventsMap>>()

  const authUser = isOnPrem() ? username : userId
  const authSession = isOnPrem() ? undefined : sessionId

  useEffect(() => {
    const connectedSocket = connect({
      auth: { userId: authUser, sessionId: authSession },
    })

    setSocket(connectedSocket)

    return () => {
      connectedSocket.off('connect_error')
      connectedSocket.close()
    }
  }, [authUser, authSession])

  return (
    <WebSocketContext.Provider value={socket}>
      {children}
    </WebSocketContext.Provider>
  )
}